var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPng(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 70,
    viewBox: "0 0 60 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "68xbfy4s1a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15554",
    style: {
      fill: "none"
    },
    d: "M0 0h60v70H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59804",
    d: "m0 38.841 4.5 3.765v-3.765z",
    transform: "translate(0 -11.227)",
    style: {
      fill: "#006831"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 893"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 892",
    style: {
      clipPath: "url(#68xbfy4s1a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59805",
    d: "M44.456 0H8.789a3.4 3.4 0 0 0-3.378 3.419v63.163A3.4 3.4 0 0 0 8.789 70h49.442a3.4 3.4 0 0 0 3.378-3.418V17.453a.712.712 0 0 0-.2-.5L44.955.21a.7.7 0 0 0-.5-.21",
    transform: "translate(-1.61)",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59806",
    d: "M58.529 69.578H9.086a2.692 2.692 0 0 1-2.675-2.708V3.707A2.692 2.692 0 0 1 9.086 1h35.668L61.2 17.742V66.87a2.692 2.692 0 0 1-2.676 2.708",
    transform: "translate(-1.907 -.289)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15549",
    transform: "translate(15.471 34.289)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15550",
    transform: "translate(15.471 42.829)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15551",
    transform: "translate(15.471 51.369)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15552",
    transform: "translate(15.471 59.91)",
    style: {
      fill: "#ddd"
    },
    d: "M0 0h32.859v1.422H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15553",
    transform: "translate(0 11.904)",
    style: {
      fill: "#0bb560"
    },
    d: "M0 0h34.523v15.71H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59807",
    d: "M12.835 27.177V29.7h-1.169v-6.809h2.574a2.59 2.59 0 0 1 1.792.6 2.013 2.013 0 0 1 .663 1.573 1.944 1.944 0 0 1-.651 1.561 2.708 2.708 0 0 1-1.82.557zm0-.954h1.405a1.375 1.375 0 0 0 .953-.3 1.1 1.1 0 0 0 .328-.859 1.189 1.189 0 0 0-.332-.882 1.276 1.276 0 0 0-.915-.339h-1.439z",
    transform: "translate(-3.47 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59808",
    d: "M25.753 29.7h-1.17l-3-4.833V29.7h-1.17v-6.809h1.17l3.01 4.852v-4.852h1.161z",
    transform: "translate(-6.072 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59809",
    d: "M35.192 28.78a2.237 2.237 0 0 1-1.012.73 4.083 4.083 0 0 1-1.47.248 2.872 2.872 0 0 1-1.5-.389 2.572 2.572 0 0 1-1.005-1.111 3.922 3.922 0 0 1-.367-1.686v-.533a3.635 3.635 0 0 1 .731-2.412 2.517 2.517 0 0 1 2.038-.868 2.66 2.66 0 0 1 1.784.564 2.44 2.44 0 0 1 .8 1.621h-1.15a1.3 1.3 0 0 0-1.41-1.23 1.377 1.377 0 0 0-1.2.573 2.941 2.941 0 0 0-.422 1.68v.523a2.8 2.8 0 0 0 .459 1.713 1.51 1.51 0 0 0 1.278.611 1.675 1.675 0 0 0 1.277-.412v-1.334H32.64v-.9h2.552z",
    transform: "translate(-8.876 -6.579)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59810",
    d: "M12.612 30.02h-1.169a.53.53 0 0 1-.527-.533v-6.813a.53.53 0 0 1 .527-.533h2.575a3.1 3.1 0 0 1 2.141.729A2.534 2.534 0 0 1 17 24.843a2.468 2.468 0 0 1-.836 1.967 3.219 3.219 0 0 1-2.164.683h-.863v1.994a.531.531 0 0 1-.527.533m-.642-1.066h.115V26.96a.534.534 0 0 1 .29-.477.534.534 0 0 1-.29-.477v-2.377a.535.535 0 0 1 .2-.422h-.313zm3.282-5.442c.029.024.056.05.082.076a1.712 1.712 0 0 1 .491 1.263 1.618 1.618 0 0 1-.5 1.257l-.035.031a1.361 1.361 0 0 0 .66-1.295 1.485 1.485 0 0 0-.487-1.174 1.554 1.554 0 0 0-.207-.158m-2.113 1.962h.879a.94.94 0 0 0 .6-.162c.038-.033.152-.137.152-.461a.643.643 0 0 0-.176-.5.771.771 0 0 0-.554-.186h-.9z",
    transform: "translate(-3.247 -6.4)",
    style: {
      fill: "#006831"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59811",
    d: "M25.53 30.019h-1.17a.524.524 0 0 1-.445-.25L21.887 26.5v2.982a.53.53 0 0 1-.526.533H20.19a.531.531 0 0 1-.527-.533v-6.808a.531.531 0 0 1 .527-.533h1.17a.524.524 0 0 1 .445.25l2.036 3.282v-3a.531.531 0 0 1 .527-.533h1.162a.53.53 0 0 1 .527.533v6.812a.53.53 0 0 1-.527.533m-.878-1.066H25v-5.745h-.1v4.318a.533.533 0 0 1-.381.513.523.523 0 0 1-.509-.127zm-3.935 0h.117v-4.3a.533.533 0 0 1 .381-.513.524.524 0 0 1 .515.132l-.661-1.065h-.351z",
    transform: "translate(-5.849 -6.4)",
    style: {
      fill: "#006831"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59812",
    d: "M32.487 30.074a3.393 3.393 0 0 1-1.765-.462 3.106 3.106 0 0 1-1.211-1.334 4.466 4.466 0 0 1-.422-1.915v-.541a4.169 4.169 0 0 1 .856-2.758 3.031 3.031 0 0 1 2.44-1.055 3.174 3.174 0 0 1 2.124.689 2.967 2.967 0 0 1 .979 1.961.539.539 0 0 1-.127.42.523.523 0 0 1-.4.181h-1.142a.528.528 0 0 1-.52-.449.779.779 0 0 0-.89-.781.85.85 0 0 0-.769.352 2.464 2.464 0 0 0-.322 1.374v.518a2.3 2.3 0 0 0 .352 1.389.99.99 0 0 0 .859.4 1.648 1.648 0 0 0 .75-.137v-.542h-.861a.53.53 0 0 1-.527-.533v-.9a.53.53 0 0 1 .527-.533h2.552a.53.53 0 0 1 .527.533v2.61a.535.535 0 0 1-.11.324 2.76 2.76 0 0 1-1.243.9 4.616 4.616 0 0 1-1.657.282m1.7-3.587a.535.535 0 0 1 .143.364v1.334a.536.536 0 0 1-.143.364 1.177 1.177 0 0 1-.086.087 1.59 1.59 0 0 0 .34-.269v-1.88zm.781 2.077zm-3.977-5.051a1.889 1.889 0 0 0-.244.243 3.141 3.141 0 0 0-.6 2.066v.533a3.391 3.391 0 0 0 .313 1.45 2.1 2.1 0 0 0 .568.728 2.36 2.36 0 0 1-.192-.223 3.323 3.323 0 0 1-.568-2.036v-.524a3.416 3.416 0 0 1 .523-1.992 1.82 1.82 0 0 1 .206-.245m3.237.681h.07a1.639 1.639 0 0 0-.457-.67 1.868 1.868 0 0 1 .388.67",
    transform: "translate(-8.653 -6.362)",
    style: {
      fill: "#006831"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59813",
    d: "M12.835 27.177V29.7h-1.169v-6.809h2.574a2.59 2.59 0 0 1 1.792.6 2.013 2.013 0 0 1 .663 1.573 1.944 1.944 0 0 1-.651 1.561 2.708 2.708 0 0 1-1.82.557zm0-.954h1.405a1.375 1.375 0 0 0 .953-.3 1.1 1.1 0 0 0 .328-.859 1.189 1.189 0 0 0-.332-.882 1.276 1.276 0 0 0-.915-.339h-1.439z",
    transform: "translate(-3.47 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59814",
    d: "M25.753 29.7h-1.17l-3-4.833V29.7h-1.17v-6.809h1.17l3.01 4.852v-4.852h1.161z",
    transform: "translate(-6.072 -6.617)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59815",
    d: "M35.192 28.78a2.237 2.237 0 0 1-1.012.73 4.083 4.083 0 0 1-1.47.248 2.872 2.872 0 0 1-1.5-.389 2.572 2.572 0 0 1-1.005-1.111 3.922 3.922 0 0 1-.367-1.686v-.533a3.635 3.635 0 0 1 .731-2.412 2.517 2.517 0 0 1 2.038-.868 2.66 2.66 0 0 1 1.784.564 2.44 2.44 0 0 1 .8 1.621h-1.15a1.3 1.3 0 0 0-1.41-1.23 1.377 1.377 0 0 0-1.2.573 2.941 2.941 0 0 0-.422 1.68v.523a2.8 2.8 0 0 0 .459 1.713 1.51 1.51 0 0 0 1.278.611 1.675 1.675 0 0 0 1.277-.412v-1.334H32.64v-.9h2.552z",
    transform: "translate(-8.876 -6.579)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59816",
    d: "M62.067 17.453h16.075L60.989 0v16.362a1.085 1.085 0 0 0 1.078 1.091",
    transform: "translate(-18.142)",
    style: {
      fill: "#ddd"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPng);
export default __webpack_public_path__ + "static/media/ico_png.cf268c6180af31040894f40ff027b56e.svg";
export { ForwardRef as ReactComponent };